import { Collapse } from './bootstrap.js';

const customSelectItems = document.querySelectorAll('.custom-select-item');

customSelectItems.forEach(item => {
    const headerButton = item.querySelector('.accordion-button');

    if (!headerButton) {
        return;
    }

    const options = item.querySelectorAll('.select-option');
    const accordionBodyId = headerButton.getAttribute('data-bs-target');

    if (!accordionBodyId) {
        return;
    }

    options.forEach(option => {
        option.addEventListener('click', function () {
            const value = this.getAttribute('data-value');
            const targetSelectId = this.getAttribute('data-select-target');
            const hiddenSelect = document.getElementById(targetSelectId);

            if (!hiddenSelect) {
                return;
            }

            hiddenSelect.value = value;

            const event = new Event('change', { bubbles: true });
            hiddenSelect.dispatchEvent(event);

            const buttonTextElement = headerButton.querySelector('b');
            if (buttonTextElement) {
                buttonTextElement.textContent = this.textContent;
            } else {
                headerButton.textContent = this.textContent;
            }

            const parentOptions = item.querySelectorAll(`.select-option[data-select-target="${targetSelectId}"]`);
            parentOptions.forEach(opt => {
                opt.classList.remove('selected');
            });
            this.classList.add('selected');

            const accordionBodyEl = document.querySelector(accordionBodyId);
            if (accordionBodyEl) {
                const collapseInstance = Collapse.getInstance(accordionBodyEl);
                if (collapseInstance) {
                    collapseInstance.hide();
                }
            }
        });
    });

    const firstOption = item.querySelector('.select-option');

    if (firstOption) {
        const defaultValue = firstOption.getAttribute('data-value');
        const defaultText = firstOption.textContent;
        const targetSelectId = firstOption.getAttribute('data-select-target');
        const hiddenSelect = document.getElementById(targetSelectId);
        const buttonTextElement = headerButton.querySelector('b');

        if (hiddenSelect && targetSelectId) {
            hiddenSelect.value = defaultValue;
            firstOption.classList.add('selected');

            if (buttonTextElement) {
                buttonTextElement.textContent = defaultText;
            } else {
                headerButton.textContent = defaultText;
            }

            const initEvent = new Event('change', { bubbles: true });
            hiddenSelect.dispatchEvent(initEvent);
        }
    }
});